"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableSelectComponent = void 0;
const lodash_1 = __importDefault(require("lodash"));
const expressions_1 = require("@mwater/expressions");
const react_1 = __importDefault(require("react"));
const react_2 = require("react");
const react_select_1 = __importDefault(require("react-select"));
const contexts_1 = require("./contexts");
/** Table select component that uses custom one if available */
const TableSelectComponent = (props) => {
    const value = props.value;
    const customTableSelectComponentFactory = (0, react_2.useContext)(contexts_1.CustomTableSelectComponentFactoryContext);
    const locale = props.locale || T.locale;
    if (customTableSelectComponentFactory) {
        return react_1.default.createElement("div", null, customTableSelectComponentFactory(props));
    }
    const tables = props.schema.getTables().filter((table) => !table.deprecated);
    const options = lodash_1.default.sortBy(tables.map((table) => ({ value: table.id, label: expressions_1.ExprUtils.localizeString(table.name, locale) })), "label");
    return (react_1.default.createElement(react_select_1.default, { value: value ? options.find((t) => t.value == props.value) : null, options: options, onChange: (v) => {
            props.onChange(v ? v.value : null);
        }, menuPortalTarget: document.body, styles: { menuPortal: (style) => ({ ...style, zIndex: 2000 }) }, placeholder: T `Select...`, isClearable: true }));
};
exports.TableSelectComponent = TableSelectComponent;
